import { Container } from '../../styles/chime-react/CommonStyles';
import {
  StyledWorkaroundContent,
  StyledErrorText,
  StyledIconWrap
} from './Styled';
import CircleExclamation from '../icons/CircleExclamation';
import { StyledMaintenanceContentBox } from '../maintenance/Styled';

const TimeDiscrepancy = () => {
  return (
    <>
      <Container maxWidth="49rem" alignMiddle>
        <StyledMaintenanceContentBox>
          <StyledIconWrap>
            <CircleExclamation width="32" height="32" />
          </StyledIconWrap>
          <StyledErrorText>
            お使いの端末の時間設定が正確でない可能性があります。
            <br />
            以下の対処方法を参考に、端末の設定の変更をお願いいたします。
          </StyledErrorText>
          <StyledWorkaroundContent>
            <p className="title">対処方法</p>
            <p className="step">
              <span>①</span>
              <span>
                端末が自動的に日付と時間を取得する設定に変更してください。
              </span>
            </p>
            <p className="step">
              <span>②</span>
              <span>
                設定を変更後、ブラウザまたはアプリの再起動をしてください。
              </span>
            </p>
          </StyledWorkaroundContent>
        </StyledMaintenanceContentBox>
      </Container>
    </>
  );
};

export default TimeDiscrepancy;
